import React, { lazy } from "react"
import { Router, Redirect } from "@reach/router"
import {
  HomePage,
  ExperiencePage,
  MaintenancePage,
  LegalInfoPage,
  BuildingPage,
  EventsPage,
  AboutUsPage,
  ExperiencesPage,
  KoudpoucesPage,
  SearchPage,
  SpecialistPage,
  IENotCompatiblePage,
} from "./Pages"
import { Footer } from "./components"

import "./App.scss"

const renderMaintenancePage = () => (
  <Router>
    <MaintenancePage path="/" />
  </Router>
)

const renderDefaultRouting = () => (
  <>
    <Router>
      <HomePage path="/" />
      <ExperiencePage path="experience/:name" />
      <ExperiencesPage path="experiences" />
      <KoudpoucesPage path="koudpouces" />
      <EventsPage path="events/:experienceName" />
      <SpecialistPage path="devenez-passionnee" />

      <SearchPage path="search" />
      <BuildingPage path="faq" />
      <LegalInfoPage path="cgu" />
      <AboutUsPage path="about-us" />
      <Redirect from="*" to="/" />
    </Router>

    <Footer />
  </>
)

const createRouting = () => {
  return process.env.IS_UNDER_MAINTENANCE
    ? renderMaintenancePage()
    : renderDefaultRouting()
}

function detectIE() {
  var ua = window.navigator.userAgent
  var msie = ua.indexOf("MSIE ")
  if (msie > 0) {
    return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10)
  }

  var trident = ua.indexOf("Trident/")
  if (trident > 0) {
    var rv = ua.indexOf("rv:")
    return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10)
  }

  var edge = ua.indexOf("Edge/")
  if (edge > 0) {
    return parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10)
  }

  return false
}

var version = detectIE()

const App = () =>
  version && version < 12 ? (
    <IENotCompatiblePage>IE</IENotCompatiblePage>
  ) : (
    createRouting()
  )

export default App
